import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { Grid, Dialog, Button, IconButton, Select, MenuItem, FormControl, InputLabel, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import './modalDatosIniciales.css';

import { AutocompleteCustomers } from './AutocompleteCustomers';
import { iniUpdateBudget, iniUpdateBudgetModeTemplate, iniSaveBudget } from '../../../redux/actions/pptos';
import { toast } from 'react-toastify';
import { AutocompleteRelacionados } from './AutocompleteRelacionados';
// import { verifyRules } from '../../../helpers/pptosProfits';
import { DialogProfileContact } from '../../contactos/DialogProfileContact';
import { Contacts } from '../../contactos/model';
import NumberFormat from 'react-number-format';

export const PptosFormModalDatosIniciales = ({ open, handleClose }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { unitList, executiveList, currencyList, detail } = useSelector(state => state.general)
    const { modo_arquitectura } = detail

    const { local_simbolo, local_separacion_miles, local_separacion_decimales } = useSelector(state => state.general.info)

    const [openEditContacto, setOpenEditContacto] = useState(false)
    const [initialStateContacto, setInitialStateContacto] = useState({})

    const detailBudget = useSelector(state => state.ppto.detail)
    const { referencia, id_cliente, cliente, id_area_negocio, area_negocio, id_ejecutivo, ejecutivo, id_moneda, moneda,
        contacto_id, contacto_nombre, contacto_email, fecha_asignacion, validacion_id_regla, validacion_rentabilidad_optima,
        validacion_descripcion_regla, reading_mode, valor_tipo_cambio, template_mode, ubicacion, area_construida, medida_construida
    } = detailBudget

    const [openContacto, setOpenContacto] = useState(false)

    const [form, setForm] = useState({
        id_cliente: id_cliente,
        cliente: cliente,
        referencia: referencia,
        id_area_negocio: id_area_negocio,
        area_negocio: area_negocio,
        id_ejecutivo: id_ejecutivo,
        ejecutivo: ejecutivo,
        id_moneda: id_moneda,
        moneda: moneda,
        contacto_id: contacto_id,
        contacto_nombre: contacto_nombre,
        contacto_email: contacto_email,
        fecha_asignacion: fecha_asignacion,
        validacion_id_regla: validacion_id_regla,
        validacion_rentabilidad_optima: validacion_rentabilidad_optima,
        validacion_descripcion_regla: validacion_descripcion_regla,
        reading_mode: reading_mode,
        valor_tipo_cambio: valor_tipo_cambio,
        ubicacion: ubicacion,
        area_construida: area_construida,
        medida_construida: medida_construida
    })

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value,
        })
    }

    const handleChangeTipoCambio = (value) => {
        setForm({
            ...form,
            'valor_tipo_cambio': value.floatValue,
        });
    }

    const handleChangeDate = (newValue) => {
        setForm({
            ...form,
            fecha_asignacion: newValue
        })
    }

    const handleChangeCustomer = (customer) => {
        setForm({
            ...form,
            id_cliente: customer.id_cliente,
            cliente: customer.cliente,
            contacto_id: 0,
            contacto_nombre: null,
            contacto_email: null
        })

        setOpenContacto(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        /*  let newRule = {
             id: form.validacion_id_regla,
             percent: form.validacion_rentabilidad_optima,
             description: form.validacion_descripcion_regla
         }
 
         if (form.id_area_negocio !== id_area_negocio) {
             newRule = await verifyRules(rules, form.id_area_negocio)
         }
  */
        let valorTipoCambio = 0
        if (parseFloat(form.id_moneda) === 4) {
            valorTipoCambio = form?.valor_tipo_cambio || 0
        }

        if (parseFloat(form.id_moneda) === 4 && parseFloat(valorTipoCambio) === 0 && !template_mode) {
            toast.warning('Falta ingresar tipo de cambio')
            return false
        }

        const newDetail = {
            ...detailBudget,
            'id_cliente': form.id_cliente,
            'cliente': form.cliente,
            'referencia': form.referencia,
            'id_area_negocio': form.id_area_negocio,
            'area_negocio': form.area_negocio,
            'id_ejecutivo': form.id_ejecutivo,
            'ejecutivo': form.ejecutivo,
            'id_moneda': form.id_moneda,
            'moneda': form.moneda,
            'contacto_id': form.contacto_id,
            'contacto_nombre': form.contacto_nombre,
            'contacto_email': form.contacto_email,
            'fecha_asignacion': form.fecha_asignacion,
            /* 'validacion_id_regla': newRule?.id,
            'validacion_rentabilidad_optima': newRule?.percent,
            'validacion_descripcion_regla': newRule?.description, */
            'valor_tipo_cambio': valorTipoCambio,
            'ubicacion': form.ubicacion,
            'area_construida': form.area_construida,
            'medida_construida': form.medida_construida
        }

        if (newDetail.id > 0 && !template_mode) {

            const originalDetailRaw = localStorage.getItem('budget-detail-init-data')
            const originalDetailObj = originalDetailRaw ? JSON.parse(originalDetailRaw) : null
            const isDirty = JSON.stringify(newDetail) !== JSON.stringify(originalDetailObj)
            if (!isDirty) {
                toast.info('No se han detectado cambios para guardar')
                return false
            }

            dispatch(iniUpdateBudget(newDetail))

        } else {
            if (template_mode) {
                dispatch(iniUpdateBudgetModeTemplate(newDetail))
            } else {
                dispatch(iniSaveBudget(newDetail, navigate))
            }
        }

        handleClose()

    }

    const handleOpenEditContacto = async () => {
        let data = await Contacts.getOne(form.contacto_id)
        setInitialStateContacto(data)
        setOpenEditContacto(true)
    }

    useEffect(() => {
        setOpenContacto(form.contacto_id ? true : false)
    }, [form.contacto_id])

    return (
        <Dialog
            className='dialogoCrearPresupuesto'
            open={open}
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
        >
            <div className='ContainerDialogs'>
                <h1 className='TitleModalPresupuesto'>
                    {'Información inicial'}
                    <IconButton
                        style={{ padding: '0', float: 'right' }}
                        aria-label="close"
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </h1>
                <form onSubmit={handleSubmit} style={{ marginTop: '30px' }}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                                <Grid item xs={12}>
                                    <TextField
                                        // ref={inputRef}
                                        className='p-box-referencia'
                                        label="Nombre o referencia de la venta"
                                        name="referencia"
                                        id="outlined-size-small"
                                        value={form.referencia || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese nombre de lo que estás cotizando'
                                        onChange={handleChange}
                                        disabled={reading_mode}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <AutocompleteCustomers
                                        form={form}
                                        handleChangeCustomer={handleChangeCustomer}
                                    />
                                    <button
                                        type='button'
                                        className='p-add-contacto'
                                        onClick={() => setOpenContacto(!openContacto)}
                                    >
                                        {!openContacto ? 'Agregar contacto' : 'Quitar contacto'}
                                    </button>
                                </Grid>

                                {openContacto &&
                                    <>
                                        <Grid item xs={parseInt(form.contacto_id) > 0 ? 11 : 12}>
                                            <AutocompleteRelacionados
                                                form={form}
                                                setForm={setForm}
                                            />
                                        </Grid>
                                        {parseInt(form.contacto_id) > 0 &&
                                            <Grid item xs={1}>
                                                <i
                                                    className="bi bi-pencil"
                                                    onClick={handleOpenEditContacto}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            </Grid>
                                        }
                                    </>
                                }

                                {openEditContacto && (
                                    <DialogProfileContact
                                        open={openEditContacto}
                                        setOpen={setOpenEditContacto}
                                        initialState={initialStateContacto}
                                    />
                                )}

                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Unidad de negocio</InputLabel>
                                        <Select
                                            label="Unidad de negocio"
                                            id="id_area_negocio"
                                            name="id_area_negocio"
                                            value={form.id_area_negocio || ''}
                                            onChange={handleChange}
                                            className='p-list-capitalize'
                                            disabled={reading_mode}
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {unitList.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Ejecutivo</InputLabel>
                                        <Select
                                            label="Ejecutivo"
                                            id="id_ejecutivo"
                                            name="id_ejecutivo"
                                            value={form.id_ejecutivo || ''}
                                            onChange={handleChange}
                                            className='p-list-capitalize'
                                            disabled={reading_mode}
                                        >
                                            <MenuItem value={null} key={null}>Ninguno</MenuItem>
                                            {executiveList.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>
                                                    {item.nombre}{' '}{item.apellidos}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <div className='p-container-date'>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DesktopDatePicker
                                                label="Fecha asignacion"
                                                inputFormat="DD/MM/YYYY"
                                                name="fecha_asignacion"
                                                value={form.fecha_asignacion}
                                                onChange={handleChangeDate}
                                                renderInput={(params) => <TextField {...params} />}
                                                disabled={reading_mode}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Moneda</InputLabel>
                                        <Select
                                            label="Moneda"
                                            id="id_moneda"
                                            name="id_moneda"
                                            value={form.id_moneda || ''}
                                            onChange={handleChange}
                                            style={{ textTransform: 'uppercase' }}
                                            disabled={reading_mode}
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {currencyList.map(item => (
                                                <MenuItem value={item.id} key={item.id} style={{ textTransform: 'uppercase' }}>{item.nombre}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {parseInt(form.id_moneda) === 4 &&
                                    <>
                                        <Grid item xs={12} sm={6}></Grid>
                                        <Grid item xs={12} sm={6}>
                                            <NumberFormat
                                                style={{ width: '100%' }}
                                                label="Valor tipo de cambio"
                                                customInput={TextField}
                                                value={form?.valor_tipo_cambio}
                                                thousandSeparator={local_separacion_miles}
                                                decimalSeparator={local_separacion_decimales}
                                                prefix={`${local_simbolo} `}
                                                onValueChange={(values) => handleChangeTipoCambio(values, 'valor_tipo_cambio')}
                                                decimalScale={2}
                                                disabled={reading_mode}
                                            />
                                        </Grid>
                                    </>
                                }

                                {modo_arquitectura &&
                                    <>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                className='p-box-referencia'
                                                label="Ubicación"
                                                name="ubicacion"
                                                id="outlined-size-small"
                                                value={form.ubicacion || ''}
                                                size="small"
                                                fullWidth
                                                placeholder='Ingrese ubicación'
                                                onChange={handleChange}
                                                disabled={reading_mode}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <TextField
                                                label={`Área construida en (${form?.medida_construida || 'MT2'})`}
                                                type='number'
                                                name="area_construida"
                                                id="outlined-size-small"
                                                value={form.area_construida || ''}
                                                size="small"
                                                fullWidth
                                                placeholder='Ingrese área en mt2'
                                                onChange={handleChange}
                                                disabled={reading_mode}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={2}>
                                            <select
                                                style={{
                                                    padding: '10px',
                                                    border: '1px solid lightgray',
                                                    borderRadius: '3px',
                                                    width: '100%'
                                                }}
                                                name="medida_construida"
                                                value={form?.medida_construida || 'MT2'}
                                                onChange={handleChange}
                                            >
                                                <option value="MT2" selected>MT2</option>
                                                <option value="HAS">HAS</option>
                                            </select>
                                        </Grid>
                                    </>
                                }

                            </Grid>
                        </Grid>
                    </Grid>

                    {!reading_mode &&
                        <div style={{ marginTop: '27px', textAlign: 'right' }}>
                            <Button
                                id="id-button-save-ppto"
                                className='p-btn-primary'
                                variant="contained"
                                size='medium'
                                type='submit'
                            >
                                Guardar
                            </Button>
                        </div>
                    }

                </form>
            </div>
        </Dialog>
    )
}
